// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CheckboxCheck: React.FC<{ width?: number; height?: number; className?: string }> = ({
    width = 11,
    height = 9,
    className,
}) => (
    <svg className={className} focusable="false" width={width} height={height}>
        <path
            fill="currentColor"
            d="M3.6931784 6.8625379L8.8681726 1.4649938C9.0439024 1.28169 9.0439024 0.98451507 8.8681726 0.80122912L8.2317915 0.13746445C8.0560617 -0.04582148 7.771122 -0.04582148 7.5953927 0.13746445L3.3749876 4.5393524L1.4045773 2.4842117C1.2288479 2.3009081 0.94390786 2.3009081 0.76817852 2.4842117L0.131797 3.1479764C-0.043932334 3.3312802 -0.043932334 3.6284552 0.131797 3.8117411L3.0567968 6.8625197C3.2325091 7.0458236 3.517432 7.0458236 3.6931784 6.8625379Z"
        />
    </svg>
);

export default React.memo(CheckboxCheck);
